import { CameraOutlined as CameraIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CameraOutlined";
import { EmailOutlined as EmailIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/EmailOutlined";
import React from "react";
import styles from "./contact-us-non-electrical-solution.module.scss";

function OtherProductSolution() {
  return (
    <div className={styles.otherProductContainer}>
      <section>
        <h3>If your item is damaged or faulty, or received the wrong product</h3>
        <div className={styles.stepsContainer}>
          <div className={styles.stepContainer}>
            <div className={styles.iconAndSeperator}>
              <div className={styles.stepIcon}>
                <CameraIcon />
              </div>
              <div className={styles.stepSeparator} />
            </div>
            <span>Take photos of the item you received</span>
          </div>

          <div className={styles.stepContainer}>
            <div className={styles.iconAndSeperator}>
              <div className={styles.stepIcon}>
                <EmailIcon />
              </div>
            </div>
            <span>Send them to us via live chat or email and provide details about the problem. </span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OtherProductSolution;
